/**
 * Serialize the table filter contract used by ReusableTable and
 * AdvancedFiltersSheet to the API's `filter_*` query convention.
 */
export function mapColumnFiltersForQuery(columnFilters = {}, options = {}) {
    const prefix = options.prefix ?? 'filter_';
    const excluded = new Set(options.excludeKeys || []);

    return Object.entries(columnFilters || {}).reduce((query, [key, rawValues]) => {
        if (excluded.has(key)) return query;
        const values = Array.isArray(rawValues)
            ? rawValues.filter((value) => value !== null && value !== undefined && String(value).trim() !== '')
            : [];
        if (values.length > 0) query[`${prefix}${key}`] = values;
        return query;
    }, {});
}
